import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavigationBar.css";
import Logo from "../../Comon/Images/GarvanaIcon.png";
import { NAV_AREA_CITIES } from "../../data/locations";

const navItems = [
  { name: "Home",          path: "/"              },
  { name: "Services",      path: "/services"      },
  { name: "Service Areas", path: "/service-areas", dropdown: true },
  { name: "Contact",       path: "/contact"       },
  { name: "Projects",      path: "/projects"      },
  { name: "Gallery",       path: "/gallery"       },
  { name: "About Us",      path: "/about"         },
  { name: "Our Plants",    path: "/products"      },
  { name: "Price Calculator", path: "/price-calculator" },
];

export default function NavigationBar({ menuOpen, setMenuOpen }) {
  const location  = useLocation();
  const closeMenu = () => setMenuOpen(false);
  const [areasOpen, setAreasOpen] = useState(false);

  /* Close the dropdown whenever the route changes (e.g. after clicking a city) */
  useEffect(() => { setAreasOpen(false); }, [location.pathname]);

  return (
    <>
      {/* ── DESKTOP NAV ── */}
      <nav className="nav-desktop">
        {navItems.map((item) =>
          item.dropdown ? (
            <div
              className="nav-dd"
              key={item.path}
              onMouseEnter={() => setAreasOpen(true)}
              onMouseLeave={() => setAreasOpen(false)}
            >
              <Link
                to={item.path}
                className={`nav-link nav-dd__trigger ${
                  location.pathname === item.path ? "nav-link--active" : ""
                }`}
                onClick={() => setAreasOpen(false)}
              >
                {item.name} <span className={`nav-dd__caret ${areasOpen ? "nav-dd__caret--up" : ""}`}>▾</span>
              </Link>
              <div className={`nav-dd__menu ${areasOpen ? "nav-dd__menu--open" : ""}`}>
                {NAV_AREA_CITIES.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/${c.slug}`}
                    className="nav-dd__item"
                    onClick={() => setAreasOpen(false)}
                  >
                    {c.city}
                  </Link>
                ))}
                <Link
                  to="/service-areas"
                  className="nav-dd__item nav-dd__all"
                  onClick={() => setAreasOpen(false)}
                >
                  View all areas →
                </Link>
              </div>
            </div>
          ) : (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${
                location.pathname === item.path ? "nav-link--active" : ""
              }`}
            >
              {item.name}
            </Link>
          )
        )}
      </nav>

      {/* ── MOBILE OVERLAY ── */}
      <div
        className={`drawer-overlay ${menuOpen ? "drawer-overlay--open" : ""}`}
        onClick={closeMenu}
      />

      {/* ── MOBILE DRAWER ── */}
      <div className={`drawer ${menuOpen ? "drawer--open" : ""}`}>

        {/* Drawer Header — Icon + Garvaana + Enterprise row */}
        <div className="drawer__header">
          <Link to="/" className="drawer__logo-wrap" onClick={closeMenu}>
            <img
              src={Logo}
              alt="Garvaana Enterprise"
              className="drawer__logo"
            />
            <div className="drawer__logo-text">
              <span className="drawer__logo-name">Garvaana</span>
              <div className="drawer__logo-tagline-row">
                <span className="drawer__tagline-dot" />
                <span className="drawer__tagline-line" />
                <span className="drawer__logo-sub">Enterprise</span>
                <span className="drawer__tagline-line" />
                <span className="drawer__tagline-dot" />
              </div>
            </div>
          </Link>
          <button className="drawer__close" onClick={closeMenu}>✕</button>
        </div>

        {/* Nav Links */}
        <nav className="drawer__nav">
          {navItems.map((item, i) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={closeMenu}
              className={`drawer__item ${
                location.pathname === item.path ? "drawer__item--active" : ""
              }`}
              style={{ animationDelay: `${i * 0.06}s` }}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        {/* Footer */}
        <div className="drawer__footer">
          <div className="drawer__phone">
            <span>📞</span>
            <span>+91-9800040505</span>
          </div>
          <a
            href="tel:+919800040505"
            className="drawer__cta"
            onClick={closeMenu}
          >
            ✦ Book Free Consultation
          </a>
        </div>

      </div>
    </>
  );
}